import { html, LitElement, unsafeCSS, css } from 'lit';
import styles from './tab.scss?inline';

export default class SotbitTab extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        active: { type: Boolean, reflect: true },
        disabled: { type: Boolean, reflect: true },
        isLink: { type: Boolean, attribute: 'is-link' },
        href: { type: String },
    };

    constructor() {
        super();
        this.href = null;
    }

    render() {
        return html`${this.isLink
            ? html`<a href="${this.href}" class="tab-link"><slot></slot></a>`
            : html`<button class="tab-button"><slot></slot></button>`}`;
    }
}
